type FlowStep = {
  number: string;
  icon: string;
  title: string;
  descriptionLines: string[];
};

const STEPS: FlowStep[] = [
  {
    number: "01",
    icon: "person_search",
    title: "ペルソナ設計",
    descriptionLines: ["自社ページから", "AIが自動分析。"],
  },
  {
    number: "02",
    icon: "groups",
    title: "スキル診断",
    descriptionLines: ["候補者との", "マッチ度を判定。"],
  },
  {
    number: "03",
    icon: "mail",
    title: "文面作成",
    descriptionLines: ["ペルソナに合わせて", "スカウトを生成。"],
  },
  {
    number: "04",
    icon: "task_alt",
    title: "送信業務管理",
    descriptionLines: ["業務進捗を", "CSVで一括エクスポート。"],
  },
  {
    number: "05",
    icon: "bar_chart",
    title: "効果測定",
    descriptionLines: ["自社のGoogle Analyticsと連携し、スカウトの効果を測定。"],
  },
];

export function FlowOverviewSection() {
  return (
    <section className="relative border-y border-ink-100/80 bg-white" id="flow">
      <div className="mx-auto max-w-[1200px] px-6 py-24">
        <div className="text-center">
          <span className="strike-line inline-block text-[13px] font-medium text-ink-500">
            スカウト業務のすべてを1本化
          </span>
        </div>
        <ol className="mt-12 grid grid-cols-1 items-stretch gap-4 sm:grid-cols-2 lg:grid-cols-5">
          {STEPS.map((step, index) => (
            <FlowStepItem isLast={index === STEPS.length - 1} key={step.number} step={step} />
          ))}
        </ol>
      </div>
    </section>
  );
}

function FlowStepItem({ step }: { step: FlowStep; isLast: boolean }) {
  return (
    <li className="rounded-2xl border border-ink-200 bg-white p-6 transition hover:shadow-card">
      <div className="flex items-start justify-between">
        <span className="grid h-11 w-11 place-items-center rounded-xl bg-brand-50 text-brand-600">
          <span className="mi text-[24px]">{step.icon}</span>
        </span>
        <span className="num text-[20px] font-bold text-ink-300">{step.number}</span>
      </div>
      <div className="mt-4 text-[17px] font-bold">{step.title}</div>
      <p className="mt-2 text-[13px] leading-relaxed text-ink-600">
        {step.descriptionLines.map((line, i) => (
          <span key={line}>
            {line}
            {i < step.descriptionLines.length - 1 ? <br /> : null}
          </span>
        ))}
      </p>
    </li>
  );
}
